import type { RootState } from 'store';

const selectSelf = (state: RootState) => state;

export default selectSelf;
